import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  type OnInit,
} from '@angular/core';
import { SafePipe } from '@pipes/safe.pipe';

@Component({
  selector: 'market-confirm-dialog',
  standalone: true,
  imports: [SafePipe],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit, AfterViewInit {
  @Input() title = 'Xác nhận';
  @Input() content = 'Bạn có chắc chắn muốn thực hiện hành động này?';
  @Input() action = true;
  @Output() confirm = new EventEmitter<boolean>();
  @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  showModal() {
    this.dialog.nativeElement.show();
    return this.confirm.asObservable();
  }
}
